import { render, staticRenderFns } from "./treeEditRole.vue?vue&type=template&id=10f45442"
import script from "./treeEditRole.vue?vue&type=script&lang=js"
export * from "./treeEditRole.vue?vue&type=script&lang=js"
import style0 from "./treeEditRole.vue?vue&type=style&index=0&id=10f45442&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports